<template>
  <div style="width: 100%; height: 100%">
    <v-toolbar floating height="32px" class="map-custom-controls elevation-2">
      <v-divider vertical></v-divider>

      <v-btn-toggle v-model="showLabels" class="transparent">
        <v-btn text>
          <v-icon>
            mdi-label
          </v-icon>
        </v-btn>
      </v-btn-toggle>

      <v-divider vertical></v-divider>

      <v-btn-toggle v-model="showTerrain" class="transparent">
        <v-btn text>
          <v-icon>
            mdi-terrain
          </v-icon>
        </v-btn>
      </v-btn-toggle>

      <v-divider vertical></v-divider>

      <v-btn text @click="decreaseZoom()">
        <v-icon>
          mdi-minus
        </v-icon>
      </v-btn>
      <v-btn text @click="increaseZoom()">
        <v-icon>
          mdi-plus
        </v-icon>
      </v-btn>

      <!--<v-divider vertical></v-divider>

            <v-btn text @click="requestFullScreen()">
              <v-icon>
                mdi-fullscreen
              </v-icon>
            </v-btn>-->
    </v-toolbar>
    <GmapMap
      ref="map"
      :center="center"
      :zoom="zoom"
      :map-type-id="mapTypeId"
      :options="mapOptions"
      style="width: 100%; height: 100%"
    >
      <gmap-custom-marker
        v-for="m in markers"
        :key="m.vessel.id"
        :marker="m.position"
        alignment="bottom"
        :offset-y="-10"
        @click.native="clickVessel(m)"
      >
        <div class="gmaps-custom-marker">
          <img
            class="gmaps-marker-icon"
            :src="markerIcon"
            :style="'transform: rotateZ(' + getMarkerRotation(m) + 'deg)'"
          />
          <div class="gmaps-marker-label">{{ m.vessel.name }}</div>
        </div>
      </gmap-custom-marker>
    </GmapMap>
  </div>
</template>

<script>
import { gmapApi } from 'vue2-google-maps'
import GmapCustomMarker from 'vue2-gmap-custom-marker'

export default {
  name: 'GmapsMap',

  components: {
    'gmap-custom-marker': GmapCustomMarker
  },

  props: {
    markers: {
      type: Array,
      required: false,
      default: function() {
        return []
      }
    },
    onMarkerClick: {
      type: Function,
      required: false,
      default: () => {}
    },
    positionsGeoJson: {
      type: Object,
      required: false,
      default: null
    },
    vessel: {
      type: Object,
      required: false,
      default: null
    },
    fetchGeoJson: {
      type: Function,
      required: false,
      default: () => {}
    }
  },

  data: function() {
    return {
      markerIcon: 'https://s3-eu-west-1.amazonaws.com/file.usail.es/static/vessel-icon.svg',
      showLabels: 0,
      showTerrain: 0,
      showWeatherToggle: false,
      streetViewControl: true,
      center: { lat: -0, lng: -0 },
      zoom: 4,
      bounds: null,
      gMapsFirstPositionIsSet: false,
      infoWinOpen: true,
      infoOptions: {
        disableAutoPan: true,
        pixelOffset: {
          width: 0,
          height: 75
        }
      },
      mapOptions: {
        disableDefaultUI: true,
        gestureHandling: 'greedy'
      },
      mapGeoJson: null
    }
  },

  computed: {
    google: gmapApi,

    mapTypeId: function() {
      return 0 !== this.showTerrain ? 'terrain' : 'satellite'
    }
  },

  watch: {
    markers: function(newMarkers, oldMarkers) {
      if (!newMarkers) {
        return
      }

      let changed = false
      newMarkers.forEach((newMarker, index) => {
        if (typeof oldMarkers[index] === 'undefined' || newMarker.vessel.id !== oldMarkers[index].vessel.id) {
          changed = true
        }
      })

      if (changed && newMarkers.length > 0) {
        this.refreshMapPosition()
      }
    },

    mapTypeId(mapTypeId) {
      this.$refs.map.$mapPromise.then(map => {
        map.setMapTypeId(mapTypeId)
      })
    },

    positionsGeoJson(positions) {
      if (!positions) {
        this.$refs.map.$mapPromise.then(map => {
          map.data.forEach(feature => {
            if (feature === this.mapGeoJson[0]) {
              map.data.remove(feature)
            }
          })
        })

        return
      }
      this.$refs.map.$mapPromise.then(map => {
        this.mapGeoJson = map.data.addGeoJson(positions)
        map.data.setStyle({
          strokeColor: '#1D8BF1',
          strokeWeight: 3
        })
      })
    },

    vessel: function(vessel) {
      if (vessel) {
        this.refreshMapPosition(9)
      } else {
        this.refreshMapPosition()
      }
    }
  },

  methods: {
    refreshMapPosition(zoom) {
      this.$refs.map.$mapPromise.then(map => {
        this.bounds = new this.google.maps.LatLngBounds()

        if (this.vessel) {
          this.markers.forEach(marker => {
            if (marker.vessel.id === this.vessel.id) {
              this.bounds.extend(marker.position)
            }
          })
        } else {
          this.markers.forEach(marker => {
            this.bounds.extend(marker.position)
          })
        }

        map.fitBounds(this.bounds)

        if ('undefined' != typeof zoom && map.zoom < zoom) {
          map.setZoom(zoom)
        }

        const maxZoomService = new this.google.maps.MaxZoomService()

        maxZoomService.getMaxZoomAtLatLng(map.center, response => {
          if (response.status === 'OK' && map.zoom > response.zoom) {
            map.setZoom(response.zoom)
          }
        })
      })
    },

    getMarkerRotation(marker) {
      return marker.vessel.latestPosition.trueHeading || marker.vessel.latestPosition.cog || 0
    },

    clickVessel(marker) {
      this.panTo(marker.position)
      this.onMarkerClick(marker)
    },

    panTo(position) {
      this.$refs.map.$mapPromise.then(map => {
        map.panTo(position)
      })
    },

    setZoom(zoom) {
      this.$refs.map.$mapPromise.then(map => {
        map.setZoom(zoom)
      })
    },

    increaseZoom() {
      this.$refs.map.$mapPromise.then(map => {
        map.setZoom(map.zoom + 1)
      })
    },

    decreaseZoom() {
      this.$refs.map.$mapPromise.then(map => {
        map.setZoom(map.zoom - 1)
      })
    },

    requestFullScreen() {
      this.$refs.map.$mapPromise.then(() => {
        window.requestFullScreen()
      })
    }
  }
}
</script>

<style scoped lang="scss">
.map-custom-controls {
  position: absolute;
  width: auto;
  top: 30px;
  right: 15px;
  z-index: 1;

  button {
    min-width: auto;
    padding: 0 8px;
    margin: 0;
  }
}
</style>

<style lang="stylus">
.gmaps-custom-marker
    display flex
    flex-wrap wrap
    flex-direction column
    justify-content center
    align-items center

.gmaps-marker-label
    background #1E3932
    color: white
    padding 2px 10px
    font-size 0.9em
    text-align center
    border-radius 8px
    margin-top 5px
    width 80px
    min-width 80px
    line-height 1.2em

.gmaps-marker-icon {
    width 26px
    height 26px
    cursor pointer
}
</style>
